import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { createActionGroup, createFeature, createReducer, createSelector, emptyProps, on, props } from "@ngrx/store";
import { ListingPublic } from "./../../../globalTypes/listings.types";
import { AuthUserActions } from "./authUser.store";
import { searchActions } from "./search.store";

export interface ListingsState extends EntityState<ListingPublic> {
  listing: Partial<ListingPublic> | null;
  listings: ListingPublic[];
  isLoading: boolean;
}

const adapter: EntityAdapter<ListingPublic> = createEntityAdapter<ListingPublic>();

const getListingsState = (): ListingsState => adapter.getInitialState({
  listing: null,
  isLoading: true,
  listings: [],
})

export const ListingsPageActions = createActionGroup({
  source: 'LISTINGS',
  events: {
    'Listings Loading': (isLoading: boolean) => ({isLoading}),
    'Listings Loaded': props<{ listings: ListingPublic[] }>(),
    'Progress Listing': props<{ listing: Partial<ListingPublic> | null }>(),
    'Listing Updated': props<{ listingId: string, listing: Partial<ListingPublic> }>(),
    'Listings Removed': props<{ listingIds: string[] }>(),
    'Listing Removed': props<{ listingId: string }>(),
    'All Listings Removed': emptyProps(),
    'Clear Listing': emptyProps(),
    'Select Listing': props<{ listingId: string }>(),
  }
});

const reducer = createReducer(
  getListingsState(),
  on(ListingsPageActions.listingsLoading, (state, { isLoading }) => ({ ...state, isLoading })),
  on(ListingsPageActions.progressListing, (state, { listing }) => ({ ...state, listing })),
  on(ListingsPageActions.clearListing, (state) => ({ ...state, listing: null })),
  on(ListingsPageActions.listingsLoaded, (state, action) => adapter.upsertMany(action.listings, { ...state, isLoading: false })),
  on(ListingsPageActions.listingUpdated, (state, action) => adapter.updateOne({id: action.listingId, changes: action.listing }, { ...state, isLoading: false })),
  on(ListingsPageActions.listingsRemoved, (state, action) => adapter.removeMany(action.listingIds, { ...state, isLoading: false })),
  on(ListingsPageActions.listingRemoved, (state, action) => adapter.removeOne(action.listingId, { ...state, isLoading: false })),
  on(ListingsPageActions.allListingsRemoved, (state) => adapter.removeAll({ ...state, isLoading: false })),
  on(ListingsPageActions.selectListing, (state, action) => ({ ...state, listing: state.listings.find(listing=>listing.id=== action.listingId) || null })),
  on(searchActions.addMinPrice, (state) => ({ ...state, isLoading: true})),
  on(searchActions.addMaxPrice, (state) => ({ ...state, isLoading: true})),
  on(searchActions.addSearch, (state) => ({ ...state, isLoading: true})),
  on(searchActions.contains, (state) => ({ ...state, isLoading: true})),
  on(searchActions.adjustSort, (state) => ({ ...state, isLoading: true})),
  on(searchActions.clearSearch, (state) => ({ ...state, isLoading: true})),
  on(searchActions.increaseLoadAmount, (state) => ({ ...state, isLoading: true})),
  on(searchActions.setCategory, (state) => ({ ...state, isLoading: true})),
  on(searchActions.toggleFavorited, (state) => ({ ...state, isLoading: true})),
  on(AuthUserActions.logOut, (state) => (getListingsState())),
)
export const listingsFeature = createFeature({
  name: 'listings',
  reducer,
  extraSelectors: ({selectEntities, selectIds}) => ({
    selectListings: createSelector(selectIds, selectEntities, (ids, entities) => ids ? ids.map((id) => entities[id]) : []),
  })
})
